import { useCallback, useEffect, useState } from 'react'

import { areaBoundaryServices } from '../services/areaBoundaryServices'

import useErrorHandler from './useErrorHandler';

function useAreaBoundary(filters = {}, dependency = []) {
    const { errorHandler } = useErrorHandler();

    const [areaBoundaryList, setAreaBoundaryList] = useState([]);
    const [rowCount, setRowCount] = useState(0);

    const getAllAreaBoundary = useCallback(async (currentFilters) => {
        try {
            const res = await areaBoundaryServices.getAllAreaBoundary(currentFilters);
            console.log("getAllAreaBoundary => ", res);
            if (res.status === 200) {
                setAreaBoundaryList(res.data.data);
                setRowCount(res.data.rowCount);
            }
        } catch (error) {
            console.log(error);
            errorHandler('error: getAllAreaBoundary', error.response.status);
        }
    }, []);

    useEffect(() => {
        getAllAreaBoundary(filters)
    }, dependency);

    return { areaBoundaryList, rowCount };
}

export default useAreaBoundary